export enum ClosedPeriodEndpoint {
  Compartment = '/compartment',
  WorkingTime = '/working-time',
  ClosedDays = '/closed-days',
  Dock = '/dock',
}
